import axios from "axios";
import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { handle401 } from "../../../utils/handleAuthError";

const BASE_URL = "https://dev.sutmmg.codydeasoftech.in/api";

const IssueMultipleVendor = () => {

  const [showModal, setShowModal] = useState(false);
  const [items, setItems] = useState([]);
  const [actionList, setActionList] = useState([]);
  const [selectedActions, setSelectedActions] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [issueToList, setIssueToList] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedVendorType, setSelectedVendorType] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [fabricStockMap, setFabricStockMap] = useState({});
  const [fabricOriginalStockMap, setFabricOriginalStockMap] = useState({});
  const [fabricRemainingStockMap, setFabricRemainingStockMap] = useState({});
  const [showSingleModal, setShowSingleModal] = useState(false);
  const [showMultipleModal, setShowMultipleModal] = useState(false);

//   const handleOpenDetailsModal = () => setShowDetailsModal(true);
//   const handleCloseDetailModal = () => setShowDetailsModal(false);

const [saveLoading, setSaveLoading] = useState(false);
  const getToday = () => new Date().toISOString





  const formatDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);
    if (isNaN(d)) return "-";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`; // DD/MM/YYYY
  };
  const emptyItemBlock = {
    fabric_type: "",
    item_id: "",
    fabricList: [],
    measurements: [],
    stock_qty: null,
    original_stock_qty: null,
    loading: false,
    vendor_id: "",
    vendorList: [],
    member_id: "",
    memberList: [],
    selectedMembers: [],
  };

  const [itemBlocks, setItemBlocks] = useState([{ ...emptyItemBlock }]);

  const fetchFabricList = async (itemId, index) => {
    try {
      const res = await axios.post(
        `${BASE_URL}/fabricList`,
        { item_id: itemId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (res.data?.status) {
        const list = res.data.data.fabricList || [];

        // ✅ store fabric list only for this block
        setItemBlocks((prev) =>
          prev.map((b, i) => (i === index ? { ...b, fabricList: list } : b)),
        );
      } else {
        setItemBlocks((prev) =>
          prev.map((b, i) => (i === index ? { ...b, fabricList: [] } : b)),
        );
      }
    } catch (err) {
      console.log("Fabric API Error:", err);
      if (handle401(err)) return;
    }
  };

  // const fetchMembersByVendor = async (vendorId, index) => {
  //   try {
  //     const response = await axios.post( `${BASE_URL}/memberList`, {
  //       shg_id: vendorId,
  //     },
  //     {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       }
  // );

  //     const memberList = response.data?.data || [];

  //     setItemBlocks(prev =>
  //       prev.map((b, i) =>
  //         i === index
  //           ? { ...b, memberList }
  //           : b
  //       )
  //     );
  //   } catch (error) {
  //     console.error("Error fetching members:", error);
  //   }
  // };

  const fetchMembersByVendor = async (vendorId, index = null) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/memberList`,
        { shg_id: vendorId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const memberList = response.data?.data || [];

      setItemBlocks((prev) =>
        prev.map((block, i) => {
          // 🔥 If index exists → Multiple Vendor
          if (index !== null) {
            return i === index ? { ...block, memberList } : block;
          }

          // 🔥 If no index → Single Vendor
          return { ...block, memberList };
        }),
      );
    } catch (error) {
      console.error("Error fetching members:", error);
    }
  };

  const handleAddMoreItem = () => {
    setItemBlocks((prev) => [
      ...prev,
      { ...emptyItemBlock }, // stock for this new card will use fabricRemainingStockMap when fabric selected
    ]);
  };

  useEffect(() => {
    console.log("Original Stock Map:", fabricOriginalStockMap);
    console.log("Remaining Stock Map:", fabricRemainingStockMap);
  }, [fabricOriginalStockMap, fabricRemainingStockMap]);

  const today = new Date().toISOString().split("T")[0]; // "YY
  const [issues, setIssues] = useState([]);

  const [formData, setFormData] = useState({
    issue_date: today,
    item: "",
    size: "",
    qty: "",
    issue_to: "",
    beneficiary_id: "",
    tentative_return_date: "",
  });

  /* ================= FETCH ITEMS ================= */
  const fetchItems = async () => {
    try {
  const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/itemsList`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const filteredItems =
        res.data?.data?.itemsList?.filter(
          (item) => Number(item.status) !== 0,
        ) || [];

      setItems(filteredItems);
    } catch (error) {
      console.error("Items API Error:", error);
      if (handle401(error)) return;

      Swal.fire(
        "Alert",
        error?.response?.data?.message || "Failed to load items",
        "error",
      );
    }
  };

  const handleMemberSelect = (blockIndex, memberId) => {
    setItemBlocks((prev) =>
      prev.map((block, index) => {
        if (index !== blockIndex) return block;

        const alreadySelected = block.selectedMembers?.includes(memberId);

        return {
          ...block,
          selectedMembers: alreadySelected
            ? block.selectedMembers.filter((id) => id !== memberId)
            : [...(block.selectedMembers || []), memberId],
        };
      }),
    );
  };

  const fetchActionList = async () => {
    try {
  const token = localStorage.getItem("token");

      const res = await axios.get(
        `${BASE_URL}/jobWorkTypeList`,

        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const rawList = res.data?.data.jobWorkTypeList || [];

      setActionList(rawList);
    } catch (error) {
      console.error("Action list error", error);
      if (handle401(error)) return;

      Swal.fire(
        "Alert",
        error?.response?.data?.message || "Failed to load action list",
        "error",
      );
    }
  };

  const round2 = (n) => Number(Number(n || 0).toFixed(2));

  const fetchMeasurementsByItem = async (itemId, fabricId, index) => {
    if (!itemId || !fabricId) return;

    // start loader
    setItemBlocks((prev) =>
      prev.map((b, i) => (i === index ? { ...b, loading: true } : b)),
    );

    try {
      const res = await axios.post(
        `${BASE_URL}/getItemWiseFabricRequirement`,
        { item_id: itemId, fabric_id: fabricId },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        },
      );

      const measurements = res.data?.data?.overView || [];

      const usedFabric = round2(
        measurements.reduce(
          (sum, m) => sum + Number(m.fabric_requirement || 0),
          0,
        ),
      );

      // 🔥 FABRIC-LEVEL DEDUCTION (single source of truth)
      setFabricStockMap((prevFabricMap) => {
        const available = prevFabricMap[fabricId] ?? 0;
        const remaining = Math.max(0, available - usedFabric);

        // update only this table row
        setItemBlocks((prevBlocks) =>
          prevBlocks.map((b, i) =>
            i === index
              ? {
                  ...b,
                  measurements,
                  used_qty: usedFabric,
                  stock_qty: remaining,
                  loading: false,
                }
              : b,
          ),
        );

        return {
          ...prevFabricMap,
          [fabricId]: remaining,
        };
      });
    } catch (err) {
      console.error("Measurement API error", err);

      setItemBlocks((prev) =>
        prev.map((b, i) => (i === index ? { ...b, loading: false } : b)),
      );
    }
  };

  const recomputeAllRemainingStock = (blocks, originalMap) => {
    const remainingMap = { ...originalMap };

    return blocks.map((b) => {
      const fabricId = b.fabric_type;
      if (!fabricId) return b;

      const used = b.used_qty || 0;
      const prevRemaining = remainingMap[fabricId] ?? 0;
      const newRemaining = Math.max(0, prevRemaining - used);

      remainingMap[fabricId] = newRemaining;

      return {
        ...b,
        stock_qty: newRemaining,
        original_stock_qty: originalMap[fabricId] ?? 0,
      };
    });
  };

  const fetchVendorType = async () => {
    try {
  const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/vendorTypesList`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );

      console.log("Vendor Types:", res.data?.data);
      setIssueToList(res.data?.data || []);
    } catch (error) {
      if (handle401(error)) return;

      console.error("Vendor type fetch error", error);
      Swal.fire("Alert", "Failed to load vendor types", "error");
    }
  };

  const fetchVendorsByType = async (vendorTypeId, index = null) => {
    try {
  const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/vendorsList`,
        { vendor_type_id: Number(vendorTypeId) },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const vendors = res.data?.data || [];

      // 👉 If index is provided → Multiple Vendor modal
      if (index !== null) {
        setItemBlocks((prev) =>
          prev.map((block, i) =>
            i === index ? { ...block, vendorList: vendors } : block,
          ),
        );
      }
      // 👉 If index is NOT provided → Single Vendor modal
      else {
        setVendorList(vendors);
      }
    } catch (error) {
      if (handle401(error)) return;
    }
  };

  const fetchFabricStock = async (fabricId, index) => {
    try {
      const res = await axios.post(
        `${BASE_URL}/getFabricWiseCurrentStock`,
        { fabric_id: fabricId },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        },
      );

      if (res.data?.status) {
        const qty = round2(
          Number(res.data.data?.current_stock?.current_quantity || 0),
        );

        // Set original stock map (keep for reference)
        setFabricOriginalStockMap((prev) => ({
          ...prev,
          [fabricId]: qty,
        }));

        setFabricStockMap((prev) => ({
          ...prev,
          [fabricId]: prev[fabricId] ?? qty, // do NOT overwrite
        }));

        // Set directly to block without deduction
        setItemBlocks((prev) =>
          prev.map((b, i) =>
            i === index
              ? {
                  ...b,
                  original_stock_qty: qty, // ✅ ADD THIS
                  base_stock_qty: qty,
                  stock_qty: qty,
                }
              : b,
          ),
        );

        return qty;
      }
    } catch (err) {
      console.log("Stock API Error:", err);
      return 0;
    }
  };

  useEffect(() => {
    fetchVendorType();
  }, []);

  const openAddModal = () => {
    setFormData({
      issue_date: today,
      item: "",
      size: "",
      qty: "",
      issue_to: "",
      beneficiary_id: "",
      tentative_return_date: "",
    });

    setFabricOriginalStockMap({});
    setFabricRemainingStockMap({});

    setItemBlocks([emptyItemBlock]);
    fetchActionList();
    fetchItems();
    setShowModal(true);
  };

  const resetModal = () => {
    setFormData({
      issue_date: "",
      item: "",
      size: "",
      qty: "",
      issue_to: "",
      vendor_id: "",
      beneficiary_id: "",
      tentative_return_date: "",
    });

    setItemBlocks([emptyItemBlock]);
    setSelectedActions([]);
    setVendorList([]);
    setFabricOriginalStockMap({});
    setFabricRemainingStockMap({});
  };

  const handleCloseModal = () => {
    resetModal();
    setShowSingleModal(false);
    setShowMultipleModal(false);
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

//   const handleSaveMultipleVendor = async () => {
//     const payload = {
//       issue_date: formData.issue_date,
//       jobs: [2],
//       items: itemBlocks.map((b) => Number(b.item_id)),
//       fabrics: itemBlocks.map((b) => Number(b.fabric_type)),
//       vendor_types: itemBlocks.map((b) => parseInt(b.issue_to)),
//       vendors: itemBlocks.map((b) => parseInt(b.vendor_id)),
//       members: itemBlocks.map((b) =>
//         b.selectedMembers?.length
//           ? b.selectedMembers.map((id) => Number(id))
//           : [],
//       ),
//       date_of_start_returning: formData.tentative_return_date,
//     };

//     try {
//   const token = localStorage.getItem("token");

//       console.log("Single FormData:", formData);

//       const res = await axios.post(`${BASE_URL}/issueJobWorksNew`, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (res.data?.status) {
//         Swal.fire("Success", res.data.message, "success");

//         await issuedJobWorksList({
//           page: 1,
//           vendorTypeId: "",
//           vendorId: "",
//         });

//         handleCloseModal();
//       } else {
//         Swal.fire("Alert", res.data?.message || "Failed to issue job", "error");
//       }
//     } catch (error) {
//       if (handle401(error)) return;

//       Swal.fire(
//         "Alert",
//         error?.response?.data?.message || "Something went wrong",
//         "error",
//       );
//     }
//   };

const handleSaveMultipleVendor = async () => {
  setSaveLoading(true);   // 🔥 START LOADER

  const payload = {
    issue_date: formData.issue_date,
    jobs: [2],
    items: itemBlocks.map((b) => Number(b.item_id)),
    fabrics: itemBlocks.map((b) => Number(b.fabric_type)),
    vendor_types: itemBlocks.map((b) => parseInt(b.issue_to)),
    vendors: itemBlocks.map((b) => parseInt(b.vendor_id)),
    members: itemBlocks.map((b) =>
      b.selectedMembers?.length
        ? b.selectedMembers.map((id) => Number(id))
        : [],
    ),
    date_of_start_returning: formData.tentative_return_date,
  };

  try {
const token = localStorage.getItem("token");

    const res = await axios.post(`${BASE_URL}/issueJobWorksNew`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.data?.status) {
      Swal.fire("Success", res.data.message, "success");

      await issuedJobWorksList({
        page: 1,
        vendorTypeId: "",
        vendorId: "",
      });

      handleCloseModal();
    } else {
      Swal.fire("Alert", res.data?.message || "Failed to issue job", "error");
    }
  } catch (error) {
    if (handle401(error)) return;

    Swal.fire(
      "Alert",
      error?.response?.data?.message || "Something went wrong",
      "error",
    );
  } finally {
    setSaveLoading(false);
  }
};

//   const handleSaveSingleVendor = async () => {
//     if (
//       !formData.issue_date ||
//       !formData.issue_to ||
//       !formData.vendor_id ||
//       itemBlocks.some((b) => !b.item_id || !b.fabric_type) ||
//       !formData.tentative_return_date
//     ) {
//       Swal.fire("Alert", "Please fill all required fields", "error");
//       return;
//     }
//     const singleBlock = itemBlocks[0];

//     const payload = {
//       issue_date: formData.issue_date,
//       vendor_type: formData.issue_to,
//       vendor: formData.vendor_id,
//       jobs: [2],
//       items: itemBlocks.map((b) => Number(b.item_id)),
//       fabrics: itemBlocks.map((b) => Number(b.fabric_type)),
//       date_of_start_returning: formData.tentative_return_date,
//       members: singleBlock?.selectedMembers?.map((id) => Number(id)) || [],
//     };

//     try {
//   const token = localStorage.getItem("token");

//       const res = await axios.post(`${BASE_URL}/issueJobWorks`, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (res.data?.status) {
//         Swal.fire("Success", res.data.message, "success");

//         await issuedJobWorksList({
//           page: 1,
//           vendorTypeId: "",
//           vendorId: "",
//           jobWorkIds: selectedActions,
//         });

//         handleCloseModal();
//       } else {
//         Swal.fire("Alert", res.data?.message || "Failed to issue job", "error");
//       }
//     } catch (error) {
//       if (handle401(error)) return;

//       Swal.fire(
//         "Alert",
//         error?.response?.data?.message || "Something went wrong",
//         "error",
//       );
//     }
//   };

const handleSaveSingleVendor = async () => {
  if (
    !formData.issue_date ||
    !formData.issue_to ||
    !formData.vendor_id ||
    itemBlocks.some((b) => !b.item_id || !b.fabric_type) ||
    !formData.tentative_return_date
  ) {
    Swal.fire("Alert", "Please fill all required fields", "error");
    return;
  }

  setSaveLoading(true);   // 🔥 START LOADER

  const singleBlock = itemBlocks[0];

  const payload = {
    issue_date: formData.issue_date,
    vendor_type: formData.issue_to,
    vendor: formData.vendor_id,
    jobs: [2],
    items: itemBlocks.map((b) => Number(b.item_id)),
    fabrics: itemBlocks.map((b) => Number(b.fabric_type)),
    date_of_start_returning: formData.tentative_return_date,
    members: singleBlock?.selectedMembers?.map((id) => Number(id)) || [],
  };

  try {
const token = localStorage.getItem("token");

    const res = await axios.post(`${BASE_URL}/issueJobWorks`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.data?.status) {
      Swal.fire("Success", res.data.message, "success");

      await issuedJobWorksList({
        page: 1,
        vendorTypeId: "",
        vendorId: "",
        jobWorkIds: selectedActions,
      });

      handleCloseModal();
    } else {
      Swal.fire("Alert", res.data?.message || "Failed to issue job", "error");
    }
  } catch (error) {
    if (handle401(error)) return;

    Swal.fire(
      "Alert",
      error?.response?.data?.message || "Something went wrong",
      "error",
    );
  } finally {
    setSaveLoading(false);  // 🔥 STOP LOADER
  }
};

  const issuedJobWorksList = async ({
    page = 1,
    vendorTypeId = selectedVendorType,
    vendorId = formData.vendor_id, // ⚠️ use filter vendor, not modal
  } = {}) => {
    try {
      setLoading(true);

  const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/getIssuedJobWorksList`,
        {
          vendor_type_id: vendorTypeId || "",
          vendor_id: vendorId || "",
          job_work_type_ids: [2],
          page,
          per_page: perPage,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (res.data?.status) {
        setIssues(res.data.data || []);
        setTotalRecords(res.data.total_records || 0);
        setTotalPages(Math.ceil((res.data.total_records || 0) / perPage));
        setPage(page);
      } else {
        setIssues([]);
        setTotalRecords(0);
        setTotalPages(1);
      }
    } catch (err) {
      if (handle401(err)) return;
      console.error("Issued Job Works List Error:", err);
      setIssues([]);
    } finally {
      setLoading(false); // 🔥 always stop loader
    }
  };

  const theadStyle = {
    padding: "5px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    borderTopLeftRadius: "10px",
    backgroundColor: "#edf7fe",
    height: "10px",
    borderBottom: "1px solid black",
    borderTop: "1px solid black",
    textAlign: "center",
  };
  useEffect(() => {
    issuedJobWorksList({ page });
  }, [page, perPage]);

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* HEADER */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-scissors"></i> Issued Fabrics List
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  Organisation Type
                </Form.Label>
                <Form.Select
                  value={selectedVendorType}
                  onChange={(e) => {
                    const vendorTypeId = e.target.value;

                    setSelectedVendorType(vendorTypeId); // track selected type
                    setFormData({ ...formData, vendor_id: "" }); // reset vendor selection

                    if (vendorTypeId) {
                      fetchVendorsByType(vendorTypeId); // fetch vendors for this type
                    } else {
                      setVendorList([]); // clear if no type selected
                    }
                  }}
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">Select Vendor type</option>
                  {issueToList.map((v) => (
                    <option key={v.id} value={v.id}>
                      {v.vendor_type_short_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  Organisation
                </Form.Label>
                <Form.Select
                  value={formData.vendor_id || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, vendor_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                  disabled={!selectedVendorType || vendorList.length === 0} // disable if no type selected
                >
                  <option value="">Select Vendor</option>
                  {vendorList.map((v) => (
                    <option key={v.id} value={v.id}>
                      {v.vendors_master_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  Record Showing
                </Form.Label>

                <Form.Select
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                  value={perPage}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setPerPage(value);
                    setPage(1);
                  }}
                >
                  <option value={10}>10 Per Page</option>
                  <option value={25}>25 Per Page</option>
                  <option value={50}>50 Per Page</option>
                  <option value={100}>100 Per Page</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4} className="d-flex gap-3 mt-3">
              {/* SEARCH */}
              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#1565C1",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                onClick={() => issuedJobWorksList()}
              >
                <i className="fa-solid fa-magnifying-glass me-2"></i> Search
              </Button>

              {/* RESET */}
              <Button
                className="w-50 fw-semibold text-white"
                style={{
                  background: "#E53935",
                  border: "none",
                  borderRadius: "10px",
                  transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
                onMouseLeave={(e) => (e.target.style.background = "#E53935")}
                onClick={() => {
                  // Reset pagination
                  setPage(1);
                  setPerPage(10);

                  // Clear filters
                  setSelectedVendorType(""); // vendor type dropdown
                  setFormData({
                    ...formData,
                    vendor_id: "", // vendor dropdown
                  });
                  setSelectedActions([]); // selected job works

                  // Reset the list with default parameters
                  issuedJobWorksList({
                    page: 1,
                    vendorTypeId: "",
                    vendorId: "",
                    jobWorkIds: [],
                  });

                  // Clear vendor list as vendor type is cleared
                  setVendorList([]);
                }}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ADD BUTTON */}
      <Button
        className="mb-3 text-white me-3"
        style={{
          background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
          borderRadius: "10px",
        }}
        onClick={() => {
          openAddModal();
          setShowSingleModal(true);
        }}
      >
        <i className="fa-solid fa-circle-plus me-2"></i> Issue Fabric (Single
        Organisation)
      </Button>

      <Button
        className="mb-3 text-white"
        style={{
          background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
          borderRadius: "10px",
        }}
        onClick={() => {
          openAddModal();
          setShowMultipleModal(true);
        }}
      >
        <i className="fa-solid fa-circle-plus me-2"></i> Issue Fabric (Multiple
        Organisation)
      </Button>

      {/* TABLE */}
      <Card className="border-0">
        <Table hover striped responsive>
          <thead>
            <tr className="text-center">
              <th style={theadStyle}>SL</th>
              <th style={theadStyle}>Issue Date</th>
              <th style={theadStyle}>Organisation Type</th>
              <th style={theadStyle}>Organisation</th>
              <th style={theadStyle}>Job Works</th>
              <th style={theadStyle}>Tentative Return</th>
              {/* <th style={theadStyle}>Action</th> */}
            </tr>
          </thead>
          <tbody>
            {issues.length > 0 ? (
              issues.map((row, i) => (
                <tr key={i} className="text-center">
                  <td className="text-center">
                    {(page - 1) * perPage + i + 1}
                  </td>
                  <td>{formatDate(row.issue_date)}</td>
                  <td>{row.vendor_type_short_name}</td>
                  <td>{row.vendors_master_name}</td>
                  <td style={{ width: "230px" }}>
                    {row.jobs?.map((j) => j.action_name).join(", ") || "-"}
                  </td>

                  <td>{formatDate(row.date_of_start_returning)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-4">
            <nav>
              <ul className="pagination shadow-sm">
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => issuedJobWorksList({ page: 1 })}
                  >
                    «
                  </button>
                </li>

                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => issuedJobWorksList({ page: page - 1 })}
                  >
                    ‹
                  </button>
                </li>

                {getPageNumbers().map((p) => (
                  <li
                    key={p}
                    className={`page-item ${page === p ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => issuedJobWorksList({ page: p })}
                    >
                      {p}
                    </button>
                  </li>
                ))}

                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => issuedJobWorksList({ page: page + 1 })}
                  >
                    ›
                  </button>
                </li>

                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => issuedJobWorksList({ page: totalPages })}
                  >
                    »
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </Card>

      {/* MODAL multiple vendopr assign*/}
      <Modal
        show={showMultipleModal}
        onHide={() => setShowMultipleModal(false)}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          style={{ background: "#3399ff", color: "#fff" }}
        >
          <Modal.Title>Issue Fabric (Multiple Organisation)</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Issue Date */}
          <Row>
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>
                  Issue Date <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  value={formData.issue_date}
                  onChange={(e) =>
                    setFormData({ ...formData, issue_date: e.target.value })
                  }
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              {/* Tentative Return Date */}
              <Form.Group className="mb-2">
                <Form.Label>
                  Tentative Date of Start Returning{" "}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  value={formData.tentative_return_date}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      tentative_return_date: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
          </Row>

          {itemBlocks.map((block, index) => (
            <div
              key={index}
              className="mb-4 p-3 position-relative"
              style={{
                border: "1px solid #D6E6FA",
                borderRadius: "10px",
                background: "#F9FBFF",
              }}
            >
              {/* CROSS BUTTON */}
              {itemBlocks.length > 1 && ( // only show if more than 1 block
                <Button
                  size="sm"
                  variant="danger"
                  className="position-absolute top-0 end-0 m-2"
                  style={{
                    borderRadius: "10%",
                    padding: "0px 8px",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                  onClick={() =>
                    setItemBlocks((prev) => {
                      const newBlocks = prev.filter((_, i) => i !== index);
                      return recomputeAllRemainingStock(
                        newBlocks,
                        fabricOriginalStockMap,
                      );
                    })
                  }
                >
                  &times;
                </Button>
              )}

              {/* MEASUREMENT TABLE */}

              <Row className="mb-3">
                {/* ITEM */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Item <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={block.item_id}
                      onChange={(e) => {
                        const itemId = e.target.value;

                        setItemBlocks((prev) =>
                          prev.map((b, i) =>
                            i === index
                              ? {
                                  ...b,
                                  item_id: itemId,
                                  fabric_type: "",
                                  measurements: [],
                                  stock_qty: null,
                                }
                              : b,
                          ),
                        );

                        if (itemId) {
                          fetchFabricList(itemId, index); // ✅ per block
                        }
                      }}
                    >
                      <option value="">Select Item</option>
                      {/* {items.map((i) => {
  const alreadySelected = itemBlocks.some(
    (b, idx) => idx !== index && String(b.item_id) === String(i.id)
  );

  return (
    <option
      key={i.id}
      value={i.id}
      disabled={alreadySelected}
    >
      {i.item_name}
    </option>
  );
})} */}

                      {items
                        .filter(
                          (i) =>
                            !itemBlocks.some(
                              (b, idx) =>
                                idx !== index &&
                                String(b.item_id) === String(i.id),
                            ),
                        )
                        .map((i) => (
                          <option key={i.id} value={i.id}>
                            {i.item_name}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* FABRIC */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Select Fabric <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={block.fabric_type}
                      disabled={!block.item_id}
                      onChange={async (e) => {
                        const fabricId = e.target.value;
                        const itemId = block.item_id;

                        if (!fabricId || !itemId) return;

                        // reset measurements
                        setItemBlocks((prev) =>
                          prev.map((b, i) =>
                            i === index
                              ? {
                                  ...b,
                                  fabric_type: fabricId,
                                  measurements: [],
                                  stock_qty: 0,
                                }
                              : b,
                          ),
                        );

                        // 🔹 fetch stock and get the value
                        const qty = await fetchFabricStock(fabricId, index);

                        // 🔹 fetch measurements and pass stock value
                        fetchMeasurementsByItem(itemId, fabricId, index, qty);
                      }}
                    >
                      <option value="">Select Fabric</option>
                      {block.fabricList?.map((f) => (
                        <option key={f.id} value={f.id}>
                          {f.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* STOCK */}
                {/* {block.item_id && block.fabric_type && (
    <Col md={4} className="d-flex align-items-end mt-4">
  <Card
    className="w-100 border-0"
    style={{
      boxShadow: "0 6px 18px rgba(46,125,50,0.25)",
      borderRadius: "12px",
    }}
  >
    <Card.Body className="py-3 px-3 d-flex align-items-center justify-content-between">
      <div>
        <div
          style={{
            fontSize: "12px",
            fontWeight: 600,
            color: "#2E7D32",
            letterSpacing: "0.5px",
          }}
        >
          FABRIC STOCK
        </div>
        <div style={{ fontSize: "18px", fontWeight: 700, color: "#1B5E20" }}>
  {block.original_stock_qty || 0} <span style={{ fontSize: "14px" }}>mtr</span>
</div>

<div style={{ fontSize: "14px", color: "#388E3C" }}>
  Remaining: {block.stock_qty || 0} mtr
</div>

      </div>

      <div
        style={{
          background: "#C8E6C9",
          color: "#1B5E20",
          width: "42px",
          height: "42px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
        }}
      >
        <i className="fa-solid fa-layer-group"></i>
      </div>
    </Card.Body>
  </Card>
</Col>

  )} */}

                {block.item_id && block.fabric_type && (
                  <Col md={3} className="d-flex align-items-end mt-2">
                    <Card
                      className="w-100 border-0"
                      style={{
                        boxShadow: "0 3px 10px rgba(46,125,50,0.15)",
                        borderRadius: "8px",
                      }}
                    >
                      <Card.Body className="py-2 px-3 d-flex align-items-center justify-content-between">
                        <div>
                          <div
                            style={{
                              fontSize: "10px",
                              fontWeight: 600,
                              color: "#2E7D32",
                              letterSpacing: "0.4px",
                            }}
                          >
                            FABRIC STOCK
                          </div>

                          <div
                            style={{
                              fontSize: "15px",
                              fontWeight: 700,
                              color: "#1B5E20",
                              lineHeight: "18px",
                            }}
                          >
                            {block.original_stock_qty ?? 0}
                            <span
                              style={{ fontSize: "11px", marginLeft: "3px" }}
                            >
                              mtr
                            </span>
                          </div>

                          <div
                            style={{
                              fontSize: "11px",
                              color: "#388E3C",
                              lineHeight: "14px",
                            }}
                          >
                            Remaining: {Number(block.stock_qty ?? 0).toFixed(2)}{" "}
                            {block.unit_name}
                          </div>
                        </div>

                        <div
                          style={{
                            background: "#E8F5E9",
                            color: "#1B5E20",
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                          }}
                        >
                          <i className="fa-solid fa-layer-group"></i>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                )}
              </Row>

              {/* MEASUREMENT TABLE */}
              {block.item_id && block.fabric_type && (
                <>
                  {block.loading ? (
                    <div className="text-muted text-center">
                      Loading measurements...
                    </div>
                  ) : block.measurements.length > 0 ? (
                    <Table bordered size="sm">
                      <thead className="table-light text-center">
                        <tr>
                          <th>SL</th>
                          <th>Item</th>
                          <th>Size</th>
                          {/* <th>No. of Measurements</th> */}
                          <th>Total Qty</th>
                          <th>Fabric Req. (mtr)</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {block.measurements.map((m, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{m.item_name}</td>
                            <td>{m.size}</td>
                            {/* <td>{m.measurement_count}</td> */}
                            <td>{m.total_quantity}</td>
                            <td>{m.fabric_requirement}</td> {/* ✅ Updated */}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <div className="text-muted text-center">
                      No measurements found
                    </div>
                  )}
                </>
              )}

              <Row>
                <Col md={6}>
                  {/* Issue To */}
                  <Form.Group className="mb-2">
                    <Form.Label>
                      Select Organisation Type <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={block.issue_to || ""}
                      onChange={(e) => {
                        const value = e.target.value;

                        setItemBlocks((prev) =>
                          prev.map((b, i) =>
                            i === index
                              ? {
                                  ...b,
                                  issue_to: value,
                                  vendor_id: "",
                                  vendorList: [],
                                }
                              : b,
                          ),
                        );

                        if (value) {
                          fetchVendorsByType(value, index);
                        }
                      }}
                    >
                      <option value="">Select</option>

                      {issueToList.map((i) => (
                        <option key={i.id} value={i.id}>
                          {i.vendor_type_short_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-2">
                    <Form.Label>
                      Select Organisation <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Select
                      value={block.vendor_id || ""}
                      disabled={
                        !block.issue_to || block.vendorList.length === 0
                      }
                      onChange={(e) => {
                        const value = e.target.value;

                        setItemBlocks((prev) =>
                          prev.map((b, i) =>
                            i === index
                              ? {
                                  ...b,
                                  vendor_id: value,
                                  member_id: "",
                                  memberList: [],
                                }
                              : b,
                          ),
                        );

                        if (value) {
                          fetchMembersByVendor(value, index); // 🔥 CALL MEMBER API
                        }
                      }}
                    >
                      <option value="">Select Organisation</option>

                      {block.vendorList.map((v) => (
                        <option key={v.id} value={v.id}>
                          {v.vendors_master_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {block.memberList && block.memberList.length > 0 && (
                <div className="mt-3">
                  <h6>Members</h6>

                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            checked={
                              block.selectedMembers.length ===
                                block.memberList.length &&
                              block.memberList.length > 0
                            }
                            onChange={(e) => {
                              const checked = e.target.checked;

                              setItemBlocks((prev) =>
                                prev.map((b, i) =>
                                  i === index
                                    ? {
                                        ...b,
                                        selectedMembers: checked
                                          ? b.memberList.map((m) => m.user_id)
                                          : [],
                                      }
                                    : b,
                                ),
                              );
                            }}
                          />
                        </th>
                        <th>Member Name</th>
                        <th>Mobile</th>
                        <th>Beneficiary Id</th>
                      </tr>
                    </thead>

                    <tbody>
                      {block.memberList.map((member) => (
                        <tr key={member.user_id}>
                          <td>
                            <input
                              type="checkbox"
                              checked={block.selectedMembers.includes(
                                member.user_id,
                              )}
                              onChange={(e) => {
                                const checked = e.target.checked;

                                setItemBlocks((prev) =>
                                  prev.map((b, i) => {
                                    if (i !== index) return b;

                                    let updated = [...b.selectedMembers];

                                    if (checked) {
                                      updated.push(member.user_id);
                                    } else {
                                      updated = updated.filter(
                                        (id) => id !== member.user_id,
                                      );
                                    }

                                    return {
                                      ...b,
                                      selectedMembers: updated,
                                    };
                                  }),
                                );
                              }}
                            />
                          </td>
                          <td>{member.name}</td>
                          <td>{member.mobile}</td>
                          <td>{member.beneficiary_id}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ))}

          <Row className="mt-3">
            <Col className="d-flex justify-content-end">
              <Button
                variant="success"
                className="fw-semibold text-white"
                onClick={handleAddMoreItem}
              >
                <i className="fa-solid fa-plus me-2"></i> Add More
              </Button>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowModal(false)}>Cancel</Button>
          <Button
  variant="success"
  onClick={handleSaveMultipleVendor}
  disabled={saveLoading}
>
  {saveLoading ? (
    <>
      <span className="spinner-border spinner-border-sm me-2"></span>
      Saving...
    </>
  ) : (
    "Submit"
  )}
</Button>
        </Modal.Footer>
      </Modal>

      {/* Single vendor assign modal*/}
      <Modal
        show={showSingleModal}
        onHide={() => setShowSingleModal(false)}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header
          closeButton
          style={{ background: "#3399ff", color: "#fff" }}
        >
          <Modal.Title>Issue Fabric (Single Organisation)</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Issue Date */}
          <Row>
            <Col md={4}>
              <Form.Group className="mb-2">
                <Form.Label>
                  Issue Date <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  value={formData.issue_date}
                  onChange={(e) =>
                    setFormData({ ...formData, issue_date: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              {/* Issue To */}
              <Form.Group className="mb-2">
                <Form.Label>
                  Select Organisation Type <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  value={formData.issue_to}
                  onChange={(e) => {
                    const value = e.target.value;

                    setFormData({
                      ...formData,
                      issue_to: value,
                      vendor_id: "",
                      beneficiary_id: "",
                    });

                    setVendorList([]);

                    if (value) {
                      fetchVendorsByType(value); // 🔥 API CALL
                    }
                  }}
                >
                  <option value="">Select</option>

                  {issueToList.map((i) => (
                    <option key={i.id} value={i.id}>
                      {i.vendor_type_short_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-2">
                <Form.Label>
                  Select Organisation <span className="text-danger">*</span>
                </Form.Label>

                <Form.Select
                  value={formData.vendor_id || ""}
                  disabled={!formData.issue_to || vendorList.length === 0}
                  onChange={(e) => {
                    const vendorId = e.target.value;

                    setFormData({
                      ...formData,
                      vendor_id: vendorId,
                    });

                    fetchMembersByVendor(vendorId);
                  }}
                >
                  <option value="">Select Organisation</option>

                  {vendorList.map((v) => (
                    <option key={v.id} value={v.id}>
                      {v.vendors_master_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {itemBlocks.map((block, index) => (
            <div
              key={index}
              className="mb-4 p-3 pt-5 position-relative"
              style={{
                border: "1px solid #D6E6FA",
                borderRadius: "10px",
                background: "#F9FBFF",
              }}
            >
              {/* CROSS BUTTON */}
              {itemBlocks.length > 1 && ( // only show if more than 1 block
                <Button
                  size="sm"
                  variant="danger"
                  className="position-absolute top-0 end-0 m-2"
                  style={{
                    borderRadius: "10%",
                    padding: "0px 8px",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                  onClick={() =>
                    setItemBlocks((prev) => {
                      const newBlocks = prev.filter((_, i) => i !== index);
                      // recompute remaining stock for all fabrics after removing block
                      return recomputeAllRemainingStock(
                        newBlocks,
                        fabricOriginalStockMap,
                      );
                    })
                  }
                >
                  &times;
                </Button>
              )}

              {block.memberList && block.memberList.length > 0 && (
                <div className="mt-3">
                  {" "}
                  <h6>Members</h6>{" "}
                  <table className="table table-bordered">
                    {" "}
                    <thead>
                      {" "}
                      <tr>
                        {" "}
                        <th>
                          {" "}
                          <input
                            type="checkbox"
                            checked={
                              block.selectedMembers?.length ===
                                block.memberList.length &&
                              block.memberList.length > 0
                            }
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setItemBlocks((prev) =>
                                prev.map((b, i) =>
                                  i === index
                                    ? {
                                        ...b,
                                        selectedMembers: checked
                                          ? b.memberList.map((m) => m.user_id)
                                          : [],
                                      }
                                    : b,
                                ),
                              );
                            }}
                          />{" "}
                        </th>{" "}
                        <th>Member Name</th> <th>Mobile</th>{" "}
                        <th>Beneficiary ID</th>{" "}
                      </tr>{" "}
                    </thead>{" "}
                    <tbody>
                      {" "}
                      {block.memberList.map((member) => (
                        <tr key={member.id}>
                          {" "}
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              checked={block.selectedMembers?.includes(
                                member.user_id,
                              )}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setItemBlocks((prev) =>
                                  prev.map((b, i) => {
                                    if (i !== index) return b;
                                    let updated = [
                                      ...(b.selectedMembers || []),
                                    ];
                                    if (checked) {
                                      updated.push(member.user_id);
                                    } else {
                                      updated = updated.filter(
                                        (id) => id !== member.id,
                                      );
                                    }
                                    return { ...b, selectedMembers: updated };
                                  }),
                                );
                              }}
                            />{" "}
                          </td>{" "}
                          <td>{member.name}</td> <td>{member.mobile}</td>{" "}
                          <td>{member.beneficiary_id}</td>{" "}
                        </tr>
                      ))}{" "}
                    </tbody>{" "}
                  </table>{" "}
                </div>
              )}

              {/* MEASUREMENT TABLE */}

              <Row className="mb-3">
                {/* ITEM */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Item <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={block.item_id}
                      onChange={(e) => {
                        const itemId = e.target.value;

                        setItemBlocks((prev) =>
                          prev.map((b, i) =>
                            i === index
                              ? {
                                  ...b,
                                  item_id: itemId,
                                  fabric_type: "",
                                  measurements: [],
                                  stock_qty: null,
                                }
                              : b,
                          ),
                        );

                        if (itemId) {
                          fetchFabricList(itemId, index); // ✅ per block
                        }
                      }}
                    >
                      <option value="">Select Item</option>

                      {items
                        .filter(
                          (i) =>
                            !itemBlocks.some(
                              (b, idx) =>
                                idx !== index &&
                                String(b.item_id) === String(i.id),
                            ),
                        )
                        .map((i) => (
                          <option key={i.id} value={i.id}>
                            {i.item_name}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* FABRIC */}
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Select Fabric <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={block.fabric_type}
                      disabled={!block.item_id}
                      onChange={async (e) => {
                        const fabricId = e.target.value;
                        const itemId = block.item_id;

                        if (!fabricId || !itemId) return;

                        // reset measurements
                        setItemBlocks((prev) =>
                          prev.map((b, i) =>
                            i === index
                              ? {
                                  ...b,
                                  fabric_type: fabricId,
                                  measurements: [],
                                  stock_qty: 0,
                                }
                              : b,
                          ),
                        );

                        // 🔹 fetch stock and get the value
                        const qty = await fetchFabricStock(fabricId, index);

                        // 🔹 fetch measurements and pass stock value
                        fetchMeasurementsByItem(itemId, fabricId, index, qty);
                      }}
                    >
                      <option value="">Select Fabric</option>
                      {block.fabricList?.map((f) => (
                        <option key={f.id} value={f.id}>
                          {f.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* STOCK */}
                {block.item_id && block.fabric_type && (
                  <Col md={4} className="d-flex align-items-end">
                    <Card
                      className="w-100 border-0"
                      style={{
                        boxShadow: "0 6px 18px rgba(46,125,50,0.25)",
                        borderRadius: "12px",
                      }}
                    >
                      <Card.Body className="py-3 px-3 d-flex align-items-center justify-content-between">
                        <div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: 600,
                              color: "#2E7D32",
                              letterSpacing: "0.5px",
                            }}
                          >
                            FABRIC STOCK
                          </div>
                          <div
                            style={{
                              fontSize: "18px",
                              fontWeight: 700,
                              color: "#1B5E20",
                            }}
                          >
                            {block.original_stock_qty || 0}{" "}
                            <span style={{ fontSize: "14px" }}>mtr</span>
                          </div>

                          <div style={{ fontSize: "14px", color: "#388E3C" }}>
                            Remaining: {Number(block.stock_qty ?? 0).toFixed(2)}{" "}
                            mtr
                          </div>
                        </div>

                        <div
                          style={{
                            background: "#C8E6C9",
                            color: "#1B5E20",
                            width: "42px",
                            height: "42px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "18px",
                          }}
                        >
                          <i className="fa-solid fa-layer-group"></i>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                )}
              </Row>

              {/* MEASUREMENT TABLE */}
              {block.item_id && block.fabric_type && (
                <>
                  {block.loading ? (
                    <div className="text-muted text-center">
                      Loading measurements...
                    </div>
                  ) : block.measurements.length > 0 ? (
                    <Table bordered size="sm">
                      <thead className="table-light text-center">
                        <tr>
                          <th>SL</th>
                          <th>Item</th>
                          <th>Size</th>
                          {/* <th>No. of Measurements</th> */}
                          <th>Total Qty</th>
                          <th>Fabric Req. (mtr)</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {block.measurements.map((m, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{m.item_name}</td>
                            <td>{m.size}</td>
                            {/* <td>{m.measurement_count}</td> */}
                            <td>{m.total_quantity}</td>
                            <td>{m.fabric_requirement}</td> {/* ✅ Updated */}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <div className="text-muted text-center">
                      No measurements found
                    </div>
                  )}
                </>
              )}
            </div>
          ))}

          <Row className="mt-3">
            <Col className="d-flex justify-content-end">
              <Button
                variant="success"
                className="fw-semibold text-white"
                onClick={handleAddMoreItem}
              >
                <i className="fa-solid fa-plus me-2"></i> Add More
              </Button>
            </Col>
          </Row>

          {/* Tentative Return Date */}
          <Form.Group className="mb-2">
            <Form.Label>
              Tentative Date of Start Returning{" "}
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              value={formData.tentative_return_date}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  tentative_return_date: e.target.value,
                })
              }
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowModal(false)}>Cancel</Button>
          <Button
  variant="success"
  onClick={handleSaveSingleVendor}
  disabled={saveLoading}
>
  {saveLoading ? (
    <>
      <span className="spinner-border spinner-border-sm me-2"></span>
      Saving...
    </>
  ) : (
    "Submit"
  )}
</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default IssueMultipleVendor;
